import {API_GMT_NUM, API_VCODE_GET, API_LOGIN, API_CY_UPDATE_NOTICE, API_CY_USER_INFO} from './api'
import request from './request'

/**
 * 查询用户信息
 */
export function getUserInfo () {
  return request(API_CY_USER_INFO, {
    method: 'GET'
  })
}

/**
 * 获取更新信息
 */
export function getUpdateNotice () {
  return request(API_CY_UPDATE_NOTICE, {
    method: 'GET'
  })
}

/**
 * 得到评论数据
 */
export function getGmtNum (cache, timestamp) {
  return request(API_GMT_NUM + `&cache=${cache}` + `&_=${timestamp}`, {
    method: "GET"
  })
}

/**
 * 获取验证码图片
 */
export function getVcode () {
  return request(API_VCODE_GET, {
    method: "GET"
  })
}

/**
 * 登录
 * @param values
     {name: "1"
    password: "1"
    rememberMe: true
    vcode: "1"}
 */
export function getLogin (values) {
  console.log(values.name)
  let loginUrl = `${API_LOGIN}?name=${values.name}&rememberMe=${values.rememberMe}&password=${values.password}&vcode=${values.vcode}&vipIsvId=0`
  return request(loginUrl, {
    method: "GET"
  })
}


